import React, { Component } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import {
    Loader, Link, IconButton
} from '@jutro/components';
import env from 'app-config';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { generateURL } from 'gw-portals-url-js';
import styles from './BillingDocuments.module.scss';
import metadata from './BillingDocuments.metadata.json5';
import messages from './BillingDocuments.messages';

class BillingDocuments extends Component {
    static contextType = TranslatorContext;

    static propTypes = {

        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        accountNumber: PropTypes.string
                    })
                })
            }),
            billingData: PropTypes.shape({})
        }).isRequired,
        intl: PropTypes.func.isRequired,

        match: PropTypes.shape({
            path: PropTypes.string
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
    };

    state = {
        billingDocuments: [],
        billingDocumentsSave: [],
        isLoading: false,
        isbillingDocumentsAvailable: true,
        documentInvoiceTypeValues: [],
        selectedInvoiceType: 'All'
    };

    componentDidMount() {
        this.getBillingDocumentsData();
    }

    getBillingDocumentsData = async () => {
        const { fromAccountLanding } = this.props;

        let billingInvoicesStatements = _.get(
            fromAccountLanding,
            'billingData.policyPeriodBillingSummaries[0].invoiceStatements_Ext'
        );
        let billingPastDueInvoices = _.get(
            fromAccountLanding,
            'billingData.policyPeriodBillingSummaries[0].pastDueInvoiceStatements_Ext'
        );

        let billingEarnedPremiumStatements = _.get(
            fromAccountLanding,
            'billingData.policyPeriodBillingSummaries[0].earnedPremiumStatements_Ext'
        );

        const billingDocsData = [];

        if (!_.isEmpty(billingInvoicesStatements)) {
            billingInvoicesStatements = this.addInvoiceType(billingInvoicesStatements, 'Invoices');
            billingDocsData.push(...billingInvoicesStatements);
        }
        if (!_.isEmpty(billingPastDueInvoices)) {
            billingPastDueInvoices = this.addInvoiceType(billingPastDueInvoices, 'Past Due');
            billingDocsData.push(...billingPastDueInvoices);
        }
        if (!_.isEmpty(billingEarnedPremiumStatements)) {
            billingEarnedPremiumStatements = this.addInvoiceType(billingEarnedPremiumStatements, 'Earned Premium');
            billingDocsData.push(...billingEarnedPremiumStatements);
        }

        if (!_.isEmpty(billingDocsData) && billingDocsData.length > 0) {
            const billingDocsDataTable = this.getBillingDocumentsDataTable(billingDocsData);
            this.setState({
                billingDocuments: billingDocsDataTable,
                billingDocumentsSave: billingDocsDataTable,
                isLoading: false,
                documentInvoiceTypeValues: this.getBillingInvoiceType(),
                isbillingDocumentsAvailable: billingDocsDataTable.length > 0 // FB 16137
            });
        } else {
            this.setState({ isbillingDocumentsAvailable: false, isLoading: false });
        }
    };

    addInvoiceType = (array, invoiceType) => {
        // Add an additional attribute "invoiceType" to the object.
        array.map((obj) => {
            obj.invoiceType = invoiceType;
        });
        return array;
    };

    getBillingDocumentsDataTable = (billingDocsData, sorted) => {
        let documentsArrayResult = [];
        documentsArrayResult = billingDocsData.map((data) => {
            const objData = {
                publicID: data.pdfDocumentID,
                sessionID: data.docSessionID,
                invoiceDate: this.getFormattedDate(data.date),
                description: data.type,
                invoiceType: data.invoiceType,
                invoiceType: data.invoiceType,
                date: data.date
            };
            return objData;
        });

        const sortedData = _.orderBy(documentsArrayResult, (o) => {
            return o.date;
        }, ['desc']);

        return sortedData;
    };

    sortDate = (a, b) => {
        const date1 = new Date(a);
        const date2 = new Date(b);

        if (date1 > date2) return 1;
        if (date1 < date2) return -1;
        return 0;
    };

    getCell = (items, index, property) => {
        return (
            <span>
                {items[property.id]}
            </span>
        );
    };

    getFormattedDate = (date) => {
        const { intl } = this.props;
        return intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
    };

    getIconLink = (item, index, property) => {
        const downloadLink = `${this.getDownloadLink(item)}&polBillingDoc=true&type=pdf`;
        return (
            <Link
                icon="mi-insert_drive_file"
                href={downloadLink}
                className={styles.documentName}
                target="_blank"
            >
                {}
            </Link>
        );
    };

    getBillingInvoiceHeader = () => {
        const depUrl = _.get(env, 'DEPLOYMENT_URL');
        const baseUrl = `${depUrl}/branding/5640-PCG-RI-Bill-Invoice-111021.pdf`;
        const params = {};
        const url = generateURL(baseUrl, params);
        return (
            <div className={styles.riTypeWithLOB}>
                <div>
                    <h2>Invoices&nbsp;</h2>
                </div>
                <div>
                    <Link href={`${url}`} target="_blank">
                        <IconButton
                            icon="mi-help"
                            id="IconButton"
                            tooltip={{
                                href: `${url}`,
                                link: '',
                                placement: 'top',
                                text: 'RI-Direct Bill Invoice Explanation',
                                title: ''
                            }}
                        />
                    </Link>

                </div>
            </div>
        );
    };

    getDownloadLink = (item) => {
        const { publicID, sessionID } = item;
        return GatewayDocumentService.downloadDocument(publicID, sessionID);
    };

    handleFilterValueChange = (value) => {
        this.setState({ selectedInvoiceType: value });
        let { billingDocumentsSave } = this.state;

        const filter = {
            selectedInvoiceType: value
        };
        const selectedInvoiceType = _.get(filter, 'selectedInvoiceType');

        if (selectedInvoiceType && selectedInvoiceType !== 'All') {
            billingDocumentsSave = _.filter(billingDocumentsSave, (document) => {
                return document.invoiceType === selectedInvoiceType;
            });
        }
        const billingDocuments = billingDocumentsSave;
        this.setState({ billingDocuments });
    };

    getBillingInvoiceType = () => {
        return [
            {
                code: 'All',
                name: 'All'
            },
            {
                code: 'Invoices',
                name: 'Invoices'
            },
            {
                code: 'Past Due',
                name: 'Past Due'
            },
            {
                code: 'Earned Premium',
                name: 'Earned Premium'
            },

        ];
    };

    render() {
        const {
            billingDocuments,
            isLoading,
            isbillingDocumentsAvailable,
            documentInvoiceTypeValues,
            selectedInvoiceType
        } = this.state;
        const translator = this.context;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const overrides = {
            billingDocumentsTable: {
                data: billingDocuments
            },
            billingDocInvoiceType: {
                availableValues: documentInvoiceTypeValues,
                value: selectedInvoiceType
            },
            billingContainer: {
                visible: isbillingDocumentsAvailable
            },
            billingDocsEmptyContainer: {
                visible: !isbillingDocumentsAvailable
            },
            warningMessage: {
                value: translator(messages.noBillingDocsDataLabel)
            },
            tabBillingInvoiceTitle: {
                content: this.getBillingInvoiceHeader()
            },
        };

        const resolvers = {
            resolveComponentMap: {},
            resolveCallbackMap: {
                getCell: this.getCell,
                getIconLink: this.getIconLink,
                handleFilterValueChange: this.handleFilterValueChange,
                sortDate: this.sortDate
            },
            resolveClassNameMap: styles
        };

        //const documentsPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
        //return <div className={styles.billingdocuments}>{documentsPage}</div>;
        return (
            <div className={styles.billingdocuments}>
                <MetadataContent
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    {...resolvers}
                />
            </div>
        );
    }
}

export default withRouter(withIntl(withAuthenticationContext(BillingDocuments)));
